import { Alert, Snackbar, Stack } from '@mui/material';

import useToastStore from '@/store/toast';

const ToastContainer = () => {
  const { toasts, removeToast } = useToastStore();

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        bottom: 24,
        left: 24,
        zIndex: 99999,
      }}
    >
      {toasts.map((toast) => (
        <Snackbar
          key={toast.id}
          open
          autoHideDuration={5000}
          onClose={() => removeToast(toast.id)}
          sx={{ position: 'static' }}
        >
          <Alert
            onClose={() => removeToast(toast.id)}
            severity={toast.severity}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};

export default ToastContainer;
